module.exports = __webpack_public_path__ + "static/img/status_indication02.b59c6eb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus_se/status_indication02.gif
// module id = aGB5
// module chunks = 1